var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCostarica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2536 7.82611H0.746391C0.264047 9.12609 0 10.5322 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739H23.2537C23.736 14.8739 24 13.4678 24 12C24 10.5322 23.736 9.12609 23.2536 7.82611Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.36292 0 5.10403 1.61831 2.90339 4.17389H21.0966C18.896 1.61831 15.6371 0 12 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0966 19.8261H2.90339C5.10403 22.3817 8.36292 24 12 24C15.6371 24 18.896 22.3817 21.0966 19.8261Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostarica);
export default __webpack_public_path__ + "static/media/costarica.cd9cc88b6be6d3fab0d3fe91ad756b39.svg";
export { ForwardRef as ReactComponent };